import React, { Component } from "react";

import {Helmet} from "react-helmet";
//import reactDom from 'react-dom';
//components
import Language from "../languageComponent/language";
import { Link } from "react-router-dom";
import YoutubeVideo from "../microComponents/youtubeVideo";
import GridLayout from "../microComponents/gridLayout";
import ReportLayout from "../microComponents/reportLayout";

//images
import PageBack from "../../Assets/Images/pageBack.png";
//ongoing ministries
import SerojaCycloneFundEnglish from "../../Assets/Images/ourMinistries/Ongoing/serojaCycloneEng.jpg";
import SerojaCycloneFundChinese from "../../Assets/Images/ourMinistries/Ongoing/serojaCycloneChi.jpg";
import IndiaCovid19FundEnglish from "../../Assets/Images/ourMinistries/Ongoing/indiaCovid19Eng.jpg";
import IndiaCovid19FundChinese from "../../Assets/Images/ourMinistries/Ongoing/indiaCovid19Chi.jpg";
import ChristmasGiftDonationEnglish from "../../Assets/Images/ourMinistries/Ongoing/christmasGiftDonationEng.jpg";
import ChristmasGiftDonationChinese from "../../Assets/Images/ourMinistries/Ongoing/christmasGiftDonationChi.jpg";
import BantuanBanjirFundraisingEnglish from "../../Assets/Images/ourMinistries/Ongoing/bantuanBanjirFundraisingEng.jpg";
import BantuanBanjirFundraisingChinese from "../../Assets/Images/ourMinistries/Ongoing/bantuanBanjirFundraisingChi.jpg";
import CrossBtn from "../../Assets/Images/ourMinistries/Ongoing/crossBtn.png";
//malaysia illus
import Kelantan2015A from "../../Assets/Images/ourMinistries/Malaysia/kelantan2015A.jpg";
import Kelantan2015B from "../../Assets/Images/ourMinistries/Malaysia/kelantan2015B.jpg";
import Penang2017A from "../../Assets/Images/ourMinistries/Malaysia/penang2017A.jpg";
import Penang2017B from "../../Assets/Images/ourMinistries/Malaysia/penang2017B.jpg";
import Johor2019A from "../../Assets/Images/ourMinistries/Malaysia/johor2019A.jpg";
import Johor2019B from "../../Assets/Images/ourMinistries/Malaysia/johor2019B.jpg";
import Pahang2021A from "../../Assets/Images/ourMinistries/Malaysia/pahang2021A.jpg";
import Pahang2021B from "../../Assets/Images/ourMinistries/Malaysia/pahang2021B.jpg";
//international illus
import Nepal2015A from "../../Assets/Images/ourMinistries/International/nepal2015A.jpg";
import Nepal2015B from "../../Assets/Images/ourMinistries/International/nepal2015B.jpg";
import India2015A from "../../Assets/Images/ourMinistries/International/india2015A.jpg";
import India2015B from "../../Assets/Images/ourMinistries/International/india2015B.jpg";
import Myanmar2015A from "../../Assets/Images/ourMinistries/International/myanmar2015A.jpg";
import Myanmar2015B from "../../Assets/Images/ourMinistries/International/myanmar2015B.jpg";
import India2018A from "../../Assets/Images/ourMinistries/International/india2018A.jpg";
import India2018B from "../../Assets/Images/ourMinistries/International/india2018B.jpg";
import Indonesia2018A from "../../Assets/Images/ourMinistries/International/indonesia2018A.jpg";
import Indonesia2018B from "../../Assets/Images/ourMinistries/International/indonesia2018B.jpg";
import Indonesia2018C from "../../Assets/Images/ourMinistries/International/indonesia2018C.jpg";
import Indonesia2018D from "../../Assets/Images/ourMinistries/International/indonesia2018D.jpg";
import India2019A from "../../Assets/Images/ourMinistries/International/india2019A.jpg";
import India2019B from "../../Assets/Images/ourMinistries/International/india2019B.jpg";
//covid19
import Covid19Malaysia1 from "../../Assets/Images/ourMinistries/Covid19/malaysia1.jpg";
import Covid19Malaysia2 from "../../Assets/Images/ourMinistries/Covid19/malaysia2.jpg";
import Covid19Malaysia3 from "../../Assets/Images/ourMinistries/Covid19/malaysia3.jpg";
import Covid19Malaysia4 from "../../Assets/Images/ourMinistries/Covid19/malaysia4.jpg";
import Covid19Nepal1 from "../../Assets/Images/ourMinistries/Covid19/nepal1.jpg";
import Covid19Nepal2 from "../../Assets/Images/ourMinistries/Covid19/nepal2.jpg";
import Covid19Nepal3 from "../../Assets/Images/ourMinistries/Covid19/nepal3.jpg";
//non-covid19
import NonCovid19Malaysia1 from "../../Assets/Images/ourMinistries/NonCovid19/malaysia1.jpg";
//const fontColor = {eng:"#171d22", chi:"#171d22"};

//navigation pos
const publicationsNavClassName = {news: "all-publications-nav-news", stories: "all-publications-nav-stories", videos: "all-publications-nav-videos", reports: "all-publications-nav-reports"};

//size variable content
const titleColumnTop = { landscape: "1350px", portrait: "1900px" };
const navOfferingSupportPos = { landscape: 800, portrait: 1900 };
const onGoingPopUpXPos = { false: "-200%", true: "-10%" };
const popupSubtitle = { serojaCyclone: "serojaCycloneFundTitle", indiaCovid19: "indiaCovid19FundTitle", christmasGift: "christmasGiftDonationTitle", bantuanBanjir: "bantuanBanjirFundraisingTitle" };
const popupEmbedId = { serojaCyclone: "rXzZvZkEOMw", indiaCovid19: "", christmasGift: "", bantuanBanjir: "" };
const popupPosterEng = { serojaCyclone: SerojaCycloneFundEnglish, indiaCovid19: IndiaCovid19FundEnglish, christmasGift: ChristmasGiftDonationEnglish, bantuanBanjir: BantuanBanjirFundraisingEnglish };
const popupPosterChi = { serojaCyclone: SerojaCycloneFundChinese, indiaCovid19: IndiaCovid19FundChinese, christmasGift: ChristmasGiftDonationChinese, bantuanBanjir: BantuanBanjirFundraisingChinese };
//
class OurMinistries extends Component {
  constructor(props) {
    super(props);
    this.state = { orientation: "landscape", onGoingPopUp: false, onGoingMenu: "", panelBackgroundHeight: "0px", publicationsNav: "news" };
    this.onImageLoad = this.onImageLoad.bind(this);
  }
  render() {
    return (
      <div className="container-fluid">
        <Helmet>
          <title>CAC MCRD Ministries</title>
          <meta property="og:url" content={"https://cacmcrd.netlify.app/Ministries"}/>
          <meta property="og:type" content={"organization infomation"} />
          <meta property="og:title" content={">CAC MCRD Ministries"} />
          <meta property="og:description" content={"Ministries of CAC MCRD throughout the years."} />
          <meta property="og:image" content={Kelantan2015A} />
        </Helmet>
        <div className="site-content">
          <div className="west-malaysia-ministry-title">
            <Language language={this.props.language} section="westMalaysiaMinistryTitle" />
          </div>
          <div className="ongoing-ministries">
            <p className="ongoing-title">
              <Language language={this.props.language} section="ongoingTitle" />
            </p>
            <div className="poster-panel">
              {/*<div className="poster-box" onClick={() => this.onSelectOngoing("serojaCyclone")}>
                <img className="poster-img" src={this.props.language=="eng" ? SerojaCycloneFundEnglish:SerojaCycloneFundChinese} />
                <p><Language language={this.props.language} section="serojaCycloneFundTitle"/></p>
              </div>
              <div className="poster-box" onClick={() => this.onSelectOngoing("indiaCovid19")}>
                <img className="poster-img" src={this.props.language=="eng" ? IndiaCovid19FundEnglish:IndiaCovid19FundChinese} />
                <p><Language language={this.props.language} section="indiaCovid19FundTitle"/></p>
      </div> ---deprecated*/}
              {/*<div className="poster-box" onClick={() => this.onSelectOngoing("christmasGift")}>
                  <img className="poster-img" src={this.props.language=="eng" ? ChristmasGiftDonationEnglish:ChristmasGiftDonationChinese} />
                  <p><Language language={this.props.language} section="christmasGiftDonationTitle"/></p>
    </div> ---deprecated*/}
              <div className="poster-box" onClick={() => this.onSelectOngoing("bantuanBanjir")}>
                <img className="poster-img" src={this.props.language == "eng" ? BantuanBanjirFundraisingEnglish : BantuanBanjirFundraisingChinese} />
                <p>
                  <Language language={this.props.language} section="bantuanBanjirFundraisingTitle" />
                </p>
              </div>
            </div>
          </div>
          {/*ongoing pop up menu */}
          <div className="ongoing-ministries-popup" style={{ left: onGoingPopUpXPos[this.state.onGoingPopUp] }}>
            <div className="popup-background" />
            <div className="cross-button" onClick={() => this.onCrossBtnClicked()}>
              <img style={{ width: "100%", height: "100%" }} src={CrossBtn} alt="crossBtn" />
            </div>
            <p className="ongoing-subtitle">
              <Language language={this.props.language} section={popupSubtitle[this.state.onGoingMenu]} />
            </p>
            <div className="video-panel">
              <YoutubeVideo embedId={popupEmbedId[this.state.onGoingMenu]} _style={{ width: this.props.orientation == "landscape" ? "30%" : "100%" }} />
              <img src={this.props.language == "eng" ? popupPosterEng[this.state.onGoingMenu] : popupPosterChi[this.state.onGoingMenu]} alt="Poster" style={{ width: this.props.orientation == "landscape" ? "30%" : "100%" }} />
            </div>
            {this.GetPopUpContent(this.state.onGoingMenu)}
            {/*<Link to="/GetInvolved" style={{zIndex:5, alignSelf:'flex-end'}}><button className="ongoing-btn" onClick={() => this.onNavigateToSection(navOfferingSupportPos[this.props.orientation])}><Language language={this.props.language} section="ongoingBtn"/></button></Link> ---deprecated*/}
          </div>
          <span>&nbsp;&nbsp;</span>
          <div className="line-separator" />
          {/*Ministry History */}
          <p className="history-title">
            <Language language={this.props.language} section="ministryHistoryTitle" />
          </p>
          <div className="natural-disaster-ministries" style={{ display: "flex", flexDirection: "row" }}>
            <div className="title-column">
              <p>
                <Language language={this.props.language} section="malaysiaTitle" />
              </p>
              <p style={{ position: "relative", top: titleColumnTop[this.state.orientation] }}>
                <Language language={this.props.language} section="internationalTitle" />
              </p>
            </div>
            <div className="timeline-column">
              <div className="timeline" />
            </div>
            <div className="ministrytitle-column">
              {/*malaysia*/}
              <p className="time-chapter">2021</p>
              <p>
                <Language language={this.props.language} section="pahang2021" />
              </p>
              <img src={Pahang2021A} alt="Pahang2021A" />
              <img src={Pahang2021B} alt="Pahang2021B" />

              <p className="time-chapter">2019</p>
              <p>
                <Language language={this.props.language} section="johor2019" />
              </p>
              <img src={Johor2019A} alt="Johor2019A" />
              <img src={Johor2019B} alt="Johor2019B" />

              <p className="time-chapter">2017</p>
              <p>
                <Language language={this.props.language} section="sarawak2017" />
              </p>
              <p>
                <Language language={this.props.language} section="selangor2017" />
              </p>
              <p>
                <Language language={this.props.language} section="penang2017" />
              </p>
              <img src={Penang2017A} alt="Penang2017A" />
              <img src={Penang2017B} alt="Penang2017B" />

              <p className="time-chapter">2015</p>
              <p>
                <Language language={this.props.language} section="kelantan2015" />
              </p>
              <img src={Kelantan2015A} alt="Kelantan2015A" />
              <img src={Kelantan2015B} alt="Kelantan2015B" />

              {/*international*/}
              <p className="time-chapter">2019</p>
              <p>
                <Language language={this.props.language} section="india2019" />
              </p>
              <img src={India2019A} alt="India2019A" />
              <img src={India2019B} alt="India2019B" />

              <p className="time-chapter">2018</p>
              <p>
                <Language language={this.props.language} section="india2018" />
              </p>
              <img src={India2018A} alt="India2018A" />
              <img src={India2018B} alt="India2018B" />
              <p>
                <Language language={this.props.language} section="indonesia2018A" />
              </p>
              <img src={Indonesia2018A} alt="Indonesia2018A" />
              <img src={Indonesia2018B} alt="Indonesia2018B" />

              <p>
                <Language language={this.props.language} section="indonesia2018B" />
              </p>
              <img src={Indonesia2018C} alt="Indonesia2018C" />
              <img src={Indonesia2018D} alt="Indonesia2018D" />

              <p className="time-chapter">2015</p>
              <p>
                <Language language={this.props.language} section="nepal2015" />
              </p>
              <img src={Nepal2015A} alt="Nepal2015A" />
              <img src={Nepal2015B} alt="Nepal2015B" />

              <p>
                <Language language={this.props.language} section="india2015" />
              </p>
              <img src={India2015A} alt="India2015A" />
              <img src={India2015B} alt="India2015B" />

              <p>
                <Language language={this.props.language} section="myanmar2015" />
              </p>
              <img src={Myanmar2015A} alt="Myanmar2015A" />
              <img src={Myanmar2015B} alt="Myanmar2015B" />
            </div>
          </div>{" "}
          {/*natural-disaster-ministry*/}
          <div className="seperator"></div>
          <div className="covid19-ministries">
            <p className="covid19-title">
              <Language language={this.props.language} section="nonCovid19Title" />
            </p>
            <img src={NonCovid19Malaysia1} alt="NonCovid19Malaysia1" />
            <p className="covid19-content-title">
              <Language language={this.props.language} section="nonCovid19Malaysia1" />
            </p>
          </div>
          <div className="seperator"></div>
          <div className="covid19-ministries">
            <p className="covid19-title">
              <Language language={this.props.language} section="covid19Title" />
            </p>
            <p className="covid19-subtitle">
              <Language language={this.props.language} section="malaysiaTitle" />
            </p>

            <img src={Covid19Malaysia1} alt="Covid19Malaysia1" />
            <p className="covid19-content-title">
              <Language language={this.props.language} section="covid19Malaysia1" />
            </p>
            <span>&nbsp;&nbsp;</span>
            <div className="line-separator" />

            <img src={Covid19Malaysia2} alt="Covid19Malaysia2" />
            <p className="covid19-content-title">
              <Language language={this.props.language} section="covid19Malaysia2" />
            </p>
            <span>&nbsp;&nbsp;</span>
            <div className="line-separator" />

            <img src={Covid19Malaysia3} alt="Covid19Malaysia3" />
            <p className="covid19-content-title">
              <Language language={this.props.language} section="covid19Malaysia3" />
            </p>
            <span>&nbsp;&nbsp;</span>
            <div className="line-separator" />

            <img src={Covid19Malaysia4} alt="Covid19Malaysia4" />
            <p className="covid19-content-title" style={{ textAlign: "left", left: "5vw" }}>
              <Language language={this.props.language} section="covid19Malaysia4Title" />
            </p>
            <p className="covid19-content" style={{ textAlign: "left", left: "5vw" }}>
              <Language language={this.props.language} section="covid19Malaysia4" mode="list" />
            </p>
            <div className="line-separator" />

            <div className="seperator"></div>
            <p className="covid19-subtitle">
              <Language language={this.props.language} section="internationalTitle" />
            </p>

            <img src={Covid19Nepal1} alt="Covid19Nepal1" />
            <p className="covid19-content-title" style={{ textAlign: "left", left: "5vw" }}>
              <Language language={this.props.language} section="covid19Nepal1Title" />
            </p>
            <p className="covid19-content" style={{ textAlign: "left", left: "5vw" }}>
              <Language language={this.props.language} section="covid19Nepal1" mode="list" />
            </p>
            <span>&nbsp;&nbsp;</span>
            <div className="line-separator" />

            <img src={Covid19Nepal2} alt="Covid19Nepal2" />
            <p className="covid19-content-title" style={{ textAlign: "left", left: "5vw" }}>
              <Language language={this.props.language} section="covid19Nepal2Title" />
            </p>
            <p className="covid19-content" style={{ textAlign: "left", left: "5vw" }}>
              <Language language={this.props.language} section="covid19Nepal2" mode="list" />
            </p>
            <span>&nbsp;&nbsp;</span>
            <div className="line-separator" />

            <img src={Covid19Nepal3} alt="Covid19Nepal3" />
            <p className="covid19-content-title" style={{ textAlign: "left", left: "5vw" }}>
              <Language language={this.props.language} section="covid19Nepal3Title" />
            </p>
            <p className="covid19-content" style={{ textAlign: "left", left: "5vw" }}>
              <Language language={this.props.language} section="covid19Nepal3" mode="list" />
            </p>
          </div>
          {/*publications */}
          <div className="seperator"></div>
          <div className="all-publications">
            <div className="all-publications-title">All Publications</div>
            <div className="all-publications-nav">
              <ul>
                <li className="all-publications-nav-news" onClick={() => this.onPublicationNavigate("news")}>News</li>
                <li className="all-publications-nav-stories" onClick={() => this.onPublicationNavigate("stories")}>Stories</li>
                <li className="all-publications-nav-videos" onClick={() => this.onPublicationNavigate("videos")}>Videos</li>
                <li className="all-publications-nav-reports" onClick={() => this.onPublicationNavigate("reports")}>Reports</li>
              </ul>
              <div className="navIndicator" style={{left:
                document.getElementsByClassName(publicationsNavClassName[this.state.publicationsNav])[0] ?
                (document.getElementsByClassName(publicationsNavClassName[this.state.publicationsNav])[0].getBoundingClientRect().left) - window.innerWidth*10/100: 0
              }}/>
            </div>
            {this.retrievePublicationContent()}
          </div>
        </div>
      </div>
    );
  }
  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }
  resize() {
    if (window.innerWidth > window.innerHeight) this.setState({ orientation: "landscape" });
    else this.setState({ orientation: "portrait" });
  }
  onImageLoad({ target: source }) {
    this.setState({
      dimensions: {
        height: source.height,
        width: source.width,
        width_height_ratio: source.width / source.height,
      },
    });
  }
  onNavigateToSection = (e) => {
    this.props.updateScrollPos(e);
  };
  onSelectOngoing = (e) => {
    this.setState({
      onGoingPopUp: true,
      onGoingMenu: e,
    });
  };
  onCrossBtnClicked = (e) => {
    this.setState({
      onGoingPopUp: !this.state.onGoingPopUp,
    });
  };
  retrievePublicationContent = (e) => {
    if(this.state.publicationsNav != "reports") {
      return(
        <GridLayout publicationsNav = {this.state.publicationsNav} updateScrollPos={this.props.updateScrollPos}/>
      );
    } else { //report layout
      return (
        <ReportLayout updateScrollPos={this.props.updateScrollPos}/>
      );
    }
  };
  onPublicationNavigate = (e) => {
    this.setState({
      publicationsNav: e
    });
  };
  GetPopUpContent = (e) => {
    let p1;
    let p2;
    let p3;
    switch (e) {
      default:
        return <div> {e} NOt Found!</div>;
      case "serojaCyclone":
        p1 = (
          <p className="ongoing-content" style={{ marginTop: "40px", textAlign: "left", left: "5vw" }}>
            <Language language={this.props.language} section="serojaCycloneFundContentA" />
          </p>
        );
        p2 = (
          <p className="ongoing-content" style={{ textAlign: "left", left: "5vw" }}>
            <Language language={this.props.language} section="serojaCycloneFundContentB" mode="list" />
          </p>
        );
        p3 = (
          <p className="ongoing-content" style={{ textAlign: "left", left: "5vw" }}>
            <Language language={this.props.language} section="serojaCycloneFundContentC" />
          </p>
        );
        return (
          <div>
            {p1}
            {p2}
            {p3}
          </div>
        );
      case "indiaCovid19":
        p1 = (
          <p className="ongoing-content" style={{ marginTop: "40px", textAlign: "left", left: "5vw" }}>
            <Language language={this.props.language} section="indiaCovid19FundContentA" />
          </p>
        );
        p2 = (
          <p className="ongoing-content" style={{ textAlign: "left", left: "5vw" }}>
            <Language language={this.props.language} section="indiaCovid19FundContentB" />
          </p>
        );
        return (
          <div>
            {p1}
            {p2}
          </div>
        );
      case "christmasGift":
        p1 = (
          <p className="ongoing-content" style={{ marginTop: "40px", textAlign: "center", left: "5vw" }}>
            <Language language={this.props.language} section="christmasGiftDonationContentA" />
          </p>
        );
        p2 = (
          <p className="ongoing-content" style={{ textAlign: "left", left: "5vw" }}>
            <Language language={this.props.language} section="christmasGiftDonationContentB" />
          </p>
        );
        return (
          <div>
            {p1}
            {p2}
          </div>
        );
      case "bantuanBanjir":
        p1 = (
          <p className="ongoing-content" style={{ marginTop: "40px", textAlign: "center", left: "5vw" }}>
            <Language language={this.props.language} section="bantuanBanjirFundraisingContentA" />
          </p>
        );
        p2 = (
          <p className="ongoing-content" style={{ textAlign: "left", left: "5vw" }}>
            <Language language={this.props.language} section="bantuanBanjirFundraisingContentB" />
          </p>
        );
        return (
          <div>
            {p1}
            {p2}
          </div>
        );
    }
  };
}
export default OurMinistries;
